export type PaymentLinkStatus = 'active' | 'used' | 'expired' | 'cancelled';
export type PaymentLinkPaymentStatus = 'paid' | 'pending' | 'failed' | 'cancelled';

export interface PaymentLinksReportFilters {
  date_from?: string | null;
  date_to?: string | null;
  payment_status?: string | null;
  search?: string | null;
  page?: number;
  per_page?: number;
}

export interface PaymentLinksReportSummary {
  total_successful_payments: number;
  total_collected_revenue: number;
  currency: string;
}

export interface PaymentLinksReportRowCustomer {
  name: string;
  mobile: string;
}

export interface PaymentLinksReportRowPlayer {
  name: string;
}

export interface PaymentLinksReportRowPackage {
  name: string;
}

export interface PaymentLinksReportRowPaymentMethod {
  source_type?: string | null;
  source_company?: string | null;
}

export interface PaymentLinksReportRow {
  id: number;
  link_reference: string;
  invoice_id?: number | null;
  invoice_academy_id?: number | null;
  transaction_id: string;
  customer: PaymentLinksReportRowCustomer;
  player: PaymentLinksReportRowPlayer;
  package: PaymentLinksReportRowPackage;
  subscription_id: number;
  amount: number;
  currency: string;
  issued_at: string | null;
  expires_at: string | null;
  paid_at: string | null;
  link_status: PaymentLinkStatus;
  payment_status: PaymentLinkPaymentStatus;
  payment_method: PaymentLinksReportRowPaymentMethod;
}

export interface PaymentLinksReportPagination {
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
  from: number;
  to: number;
}

export interface PaymentLinksReportTable {
  rows: PaymentLinksReportRow[];
  pagination: PaymentLinksReportPagination;
}

export interface PaymentLinksReportPayload {
  summary: PaymentLinksReportSummary;
  table: PaymentLinksReportTable;
  filters?: PaymentLinksReportFilters;
}

export function createEmptyPaymentLinksReportPayload(): PaymentLinksReportPayload {
  return {
    summary: {
      total_successful_payments: 0,
      total_collected_revenue: 0,
      currency: 'SAR',
    },
    table: {
      rows: [],
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1,
        from: 0,
        to: 0,
      },
    },
  };
}
